const state = {
  title: 'Профиль пользователя'
}

const mutations = {
  changeTitle: function (state, title) {
    /**
     * Устанавливает состояние страницы
     * @param {Object} state - состояние хранилища
     * @param {string} title - название страницы
     */
    state.title = title
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
